import { siteInfo } from "@/mocks/gua";

export default function Footer() {
  return (
    <footer className="mt-12 w-full border-t border-background-200 bg-background-100/80 md:mt-16">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
          <div className="max-w-md">
            <div className="flex items-center gap-2">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-base" />
              </span>
              <span className="text-lg font-black text-foreground-950">{siteInfo.name}</span>
            </div>
            <p className="mt-3 text-xs leading-5 text-foreground-600">
              色瓜网劲爆爆料合集 —— 集中收录近期网络热议的猛料与深度挖掘内容，带你快速了解每一条大瓜背后的来龙去脉与最新进展。
            </p>
          </div>
          <div className="grid grid-cols-2 gap-x-10 gap-y-1 text-sm sm:grid-cols-3">
            <a href="#" className="py-1 text-foreground-700 hover:text-accent-700">最新爆料</a>
            <a href="#" className="py-1 text-foreground-700 hover:text-accent-700">全网热榜</a>
            <a href="#" className="py-1 text-foreground-700 hover:text-accent-700">深度挖掘</a>
            <a href="#faq" className="py-1 text-foreground-700 hover:text-accent-700">关于本站</a>
            <a href="#faq" className="py-1 text-foreground-700 hover:text-accent-700">常见疑问</a>
            <a href="#" className="py-1 text-foreground-700 hover:text-accent-700">联系我们</a>
          </div>
        </div>
        <div className="mt-8 flex flex-col gap-2 border-t border-background-200 pt-5 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 色瓜网 · 内容为演示性质，仅作信息整理，不代表本站立场。</p>
          <p className="flex items-center gap-1 whitespace-nowrap">
            最后更新 {siteInfo.updatedAt} · <i className="ri-sparkling-2-fill text-accent-500" /> 持续滚动
          </p>
        </div>
      </div>
    </footer>
  );
}